var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.95 69.14c-1.12.87-21 12.07-21 36.96 0 28.8 25.3 38.98 26.05 39.23-.12.62-4.02 13.95-13.33 27.53-8.31 11.96-16.99 23.89-30.18 23.89-13.2 0-16.6-7.67-31.83-7.67-14.85 0-20.13 7.92-32.2 7.92-12.07 0-20.5-11.06-30.18-24.64C30.06 156.41 21 131.63 21 108.12 21 70.4 45.53 50.4 69.68 50.4c12.82 0 23.52 8.42 31.57 8.42 7.67 0 19.62-8.93 34.22-8.93 5.53 0 25.4.5 38.48 19.25Zm-45.41-35.21c6.04-7.16 10.3-17.1 10.3-27.03 0-1.38-.11-2.77-.36-3.9-9.82.37-21.5 6.54-28.55 14.7-5.53 6.3-10.7 16.23-10.7 26.3 0 1.51.26 3.02.37 3.5.62.12 1.63.26 2.64.26 8.81 0 19.9-5.9 26.3-13.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "assets/media/ios.9e2fcd61.svg";
export { ForwardRef as ReactComponent };